import { useCatalogChanges, useMeta } from '@numistic/data'
import { useTranslation } from '@numistic/i18n'
import { Alert, Button, Card, CardContent, CardHeader, CardTitle } from '@numistic/ui'
import { createRoute } from '@tanstack/react-router'

import { ChangeList } from '../../catalog/change-list.js'
import { useErrorText } from '../../lib/errors.js'
import { adminRoute } from './layout.js'

export const adminChangesRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/changes',
  component: ChangesPage,
})

function ChangesPage() {
  const { t } = useTranslation()
  const errorText = useErrorText()
  const meta = useMeta().data
  const changes = useCatalogChanges()
  const items = changes.data?.pages.flatMap((p) => p.items) ?? []
  if (changes.error) return <Alert variant="destructive">{errorText.request(changes.error)}</Alert>
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('history.journal')}</CardTitle>
        <p className="text-sm text-muted-foreground">{t('history.journalHint')}</p>
      </CardHeader>
      <CardContent className="grid gap-4">
        {meta && changes.data ? <ChangeList meta={meta} changes={items} withItem /> : null}
        {changes.hasNextPage ? (
          <Button
            variant="outline"
            className="justify-self-center"
            disabled={changes.isFetchingNextPage}
            onClick={() => void changes.fetchNextPage()}
          >
            {t('catalog.more')}
          </Button>
        ) : null}
      </CardContent>
    </Card>
  )
}
